import { render, staticRenderFns } from "./TextInfoSubSection.vue?vue&type=template&id=03184491&scoped=true&"
import script from "./TextInfoSubSection.vue?vue&type=script&lang=js&"
export * from "./TextInfoSubSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03184491",
  null
  
)

export default component.exports